import CalendarList, {
  CalendarItemProps
} from '@anm/components/templates/CalendarList';
import CalendarItem from '@anm/components/templates/CalendarList/CalendarItem';
import getCalendarFetchDate from '@anm/helpers/videoTemplates/getCalendarFetchDates';
import { memo, useCallback, FC } from 'react';
import { useSelector } from 'react-redux';

import routes from '../../../routes';
import { waveEventsSelectors } from '../../../store/modules/waveEvents';

import { getCalendarData } from './helpers';
import { useCalendarLinkParams } from './hooks';

const { Link } = routes;

const CalendarEventsList: FC = () => {
  const [date1, date2, date3] = getCalendarFetchDate();

  const week1 = useSelector(waveEventsSelectors.selectWaveEvents(date1));
  const week2 = useSelector(waveEventsSelectors.selectWaveEvents(date2));
  const week3 = useSelector(waveEventsSelectors.selectWaveEvents(date3));

  const renderCalendarItem = useCallback((props: CalendarItemProps) => {
    const params = useCalendarLinkParams(props.fullUrl);

    return (
      <Link route="wave-event" {...{ params }} key={props.title}>
        <a>
          <CalendarItem {...props} />
        </a>
      </Link>
    );
  }, []);

  // prevent crash on test env
  if (!week1 || !week2 || !week3) return null;

  const data = [...week1, ...week2, ...week3];

  const calendarData = getCalendarData(data);

  return (
    <CalendarList data={calendarData} {...{ renderCalendarItem }}>
      <Link route="/calendar">
        <a>See more in the Calendar →</a>
      </Link>
    </CalendarList>
  );
};

export default memo(CalendarEventsList);
